import endpoints from '@/constants/endpoints';
import axiosV2 from '@/data/api/axiosv2';
import { ITEMS_PAGE_LIMIT } from '@/utils/constants';
import { SearchBuyersResponse } from '../model/draftOrder/SearchBuyers';
import { SearchProductsResponse } from '../model/draftOrder/SearchProducts';

export async function searchBuyers(
  searchTerm: string
): Promise<SearchBuyersResponse> {
  const endpoint = endpoints.retailers.searchBuyers;
  const response: SearchBuyersResponse = await axiosV2.get(endpoint, {
    params: { limit: ITEMS_PAGE_LIMIT, filter: searchTerm },
  });
  return response;
}

export async function searchProducts(
  searchTerm: string,
  sellerIds?: string[]
): Promise<SearchProductsResponse> {
  const endpoint = endpoints.cart.searchProducts;
  const sellerIdsFilter = (sellerIds?.join(',') ?? '').trim();
  const response: SearchProductsResponse = await axiosV2.get(endpoint, {
    params: {
      query: searchTerm,
      limit: 100,
      ...(sellerIdsFilter && { seller_id: `${sellerIdsFilter}` }),
    },
  });
  return response;
}
